/* eslint-disable no-console */
import { EventSourcePolyfill } from 'event-source-polyfill';
import LocalStorageService from '../services/localstorage.service';

const localStorageService = LocalStorageService.getService();

export default {
  install (Vue) {
    // use a new Vue instance as the interface for Vue components to receive/send SSE events
    // this way every component can listen to events or send new events using this.$sharedHub
    const sharedHub = new Vue()
    Vue.prototype.$sharedHub = sharedHub

    // Provide methods to connect/disconnect from the SSE endpoint
    let eventSource = null
    let manuallyClosed = false
    let reconnectTimeout = null

    sharedHub.startSse = () => {
      if (eventSource && eventSource.readyState !== EventSourcePolyfill.CLOSED) {
        return // Already connected
      }

      manuallyClosed = false

      function connect() {
        const token = localStorageService.getAuthToken();
        
        // Create SSE connection with Bearer token authentication in headers
        const url = `${Vue.prototype.$appConfig.hubBaseUrl}/Sse/connect`;
        console.log('[SSE] Connecting to:' + url);
        eventSource = new EventSourcePolyfill(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          heartbeatTimeout: 120000 // 2 minutes instead of default 45 seconds
        });
        console.log('[SSE] EventSource created, registering event listeners...');

        // Handle connection open
        eventSource.addEventListener('open', () => {
          console.log('[SSE] Connection opened successfully');
          sharedHub.$emit('sseconnected')
          if (reconnectTimeout) {
            clearTimeout(reconnectTimeout)
            reconnectTimeout = null
          }
        });

        // Catch ALL messages for debugging (messages without event type)
        eventSource.onmessage = (event) => {
          console.log('[SSE] Received message (no event type):' + event.data);
        };

        // Handle SSE events - map backend event names to lowercase for consistency
        eventSource.addEventListener('bannerChanged', (event) => {
          console.log('[SSE] Received bannerChanged event:' + event.data);
          try {
            const data = event.data ? JSON.parse(event.data) : null;
            sharedHub.$emit('bannerchanged', data)
          } catch (error) {
            console.log('[SSE] Error parsing bannerChanged data:' + JSON.stringify(error) + ', event data:' + event.data);
          }
        });

        eventSource.addEventListener('documentReady', (event) => {
          console.log('[SSE] Received documentReady event:' + event.data);
          try {
            const data = event.data ? JSON.parse(event.data) : null;
            sharedHub.$emit('documentready', data)
          } catch (error) {
            console.log('[SSE] Error parsing documentReady data:' + JSON.stringify(error) + ', event data:' + event.data);
          }
        });

        eventSource.addEventListener('refreshMessages', (event) => {
          console.log('[SSE] Received refreshMessages event:' + event.data);
          try {
            const data = event.data ? JSON.parse(event.data) : null;
            sharedHub.$emit('refreshmessages', data)
          } catch (error) {
            console.log('[SSE] Error parsing refreshMessages data:' + JSON.stringify(error) + ', event data:' + event.data);
          }
        });

        eventSource.addEventListener('userTest', (event) => {
          console.log('[SSE] Received userTest event:' + event.data);
          try {
            const data = event.data ? JSON.parse(event.data) : null;
            sharedHub.$emit('usertest', data)
          } catch (error) {
            console.log('[SSE] Error parsing userTest data:' + JSON.stringify(error) + ', event data:' + event.data);
          }
        });

        eventSource.addEventListener('connected', (event) => {
          console.log('[SSE] Received connected event:' + event.data);
          try {
            const data = event.data ? JSON.parse(event.data) : null;
            console.log('[SSE] Connected event data:' + JSON.stringify(data));
          } catch (error) {
            console.log('[SSE] Error parsing connected data:' + JSON.stringify(error) + ', event data:' + event.data);
          }
        });

        // Handle connection errors and reconnection
        eventSource.addEventListener('error', (error) => {
          console.log('[SSE] Connection error occurred:', error);
          console.log('[SSE] ReadyState:', eventSource.readyState, 'ManuallyClosed:', manuallyClosed);
          console.log('[SSE] Error details - status:', error.status, 'statusText:', error.statusText);
          console.log('[SSE] Full error object:', JSON.stringify(error));
          
          console.log('[SSE] Connection error! ReadyState:' + eventSource.readyState + 
                ', Status:' + (error.status || 'N/A') + 
                ', StatusText:' + (error.statusText || 'N/A') + 
                ', ManuallyClosed:' + manuallyClosed);
          
          if (eventSource.readyState === EventSourcePolyfill.CLOSED && !manuallyClosed) {
            console.log('[SSE] Connection closed, will reconnect in 10 seconds...');
            // Connection closed, attempt to reconnect after delay
            if (reconnectTimeout) {
              clearTimeout(reconnectTimeout)
            }
            reconnectTimeout = setTimeout(() => {
              console.log('[SSE] Attempting to reconnect...');
              connect()
            }, 10000) // Reconnect after 10 seconds
          }
        });
      }

      connect()
    }

    sharedHub.stopSse = () => {
      manuallyClosed = true
      
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout)
        reconnectTimeout = null
      }

      if (eventSource) {
        eventSource.close()
        eventSource = null
      }
    }
  }
}